import { useState, useEffect } from "react";

export const useTourTitle = (tourTitle:{ series: string, week: string }) => {
    const [title, setTitle] = useState("");
    const [isUserEdited, setIsUserEdited] = useState(false);

    useEffect(() => {
        if (!isUserEdited) {
            const generatedTitle = [tourTitle.series, tourTitle.week]
                .filter(Boolean)
                .join(", ");
            setTitle(generatedTitle);
        }
    }, [tourTitle, isUserEdited]);

    const handleTitleChange = (value:string) => {
        setTitle(value);
        setIsUserEdited(true);
    };

    return { title, handleTitleChange,setTitle };
};

export default useTourTitle;
